// Constants module for the perks application

export const SEARCH_FILTERS = {
  PERKS_SEARCH_ROUTE: '/api/v1/perks/search',
} as const

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest',
} as const

export const REQUIRED_PROFILE_FIELDS = [
  'email',
  'firstName',
  'lastName',
] as const

export const QUERIES = {
  PAGE: true,
  TEXT: true,
  TECHSTARSCOMPANY: true,
  PARTNER: true,
  CATEGORIES: true,
  SORT: true,
  COMPANY: true,
  STAGE: true,
  KEYWORD: true,
  INVESTOR: true,
  FUND: true,
  LOCATION: true,
  INDUSTRY: true,
} as const
